/**
 * Get a single value from param by key. Mirrors PHP Helpers::getValue().
 * Supports array/object indexing; optional case-insensitive key lookup.
 */
function getValue(
  param: unknown,
  key: string | number | string[],
  defaultVal: unknown = null,
  ignoreCase = false
): unknown {
  if (Array.isArray(key)) {
    return key.map((k) => getValue(param, k, defaultVal, ignoreCase));
  }
  if (param == null || (key !== "0" && (key === "" || key == null))) {
    return defaultVal;
  }
  if (typeof param === "object") {
    const record = param as Record<string, unknown>;
    if (ignoreCase) {
      const found = Object.keys(record).find(
        (k) => k.toLowerCase() === String(key).toLowerCase()
      );
      return found !== undefined ? (record[found] ?? defaultVal) : defaultVal;
    }
    const keyStr = String(key);
    return Object.prototype.hasOwnProperty.call(record, keyStr)
      ? (record[keyStr] ?? defaultVal)
      : defaultVal;
  }
  return defaultVal;
}

/**
 * Get value by dot-separated path. Mirrors PHP Helpers::getValueByPath().
 * Supports paths like "investor.bank_details.0.account_number".
 */
export function getValueByPath(
  data: unknown,
  path: string,
  defaultVal: unknown = null,
  separator = ".",
  ignoreCase = false
): unknown {
  const keys = path.split(separator);
  let value: unknown = data;
  for (const key of keys) {
    value = getValue(value, key.trim(), defaultVal, ignoreCase);
    if (value == null) {
      return defaultVal;
    }
  }
  return value;
}
